<ng-container *transloco="let t" class="container">
  <form [formGroup]="inputForm">
    <div class="modal-body">
      <div class="d-flex align-items-center pb-4">
        <img src="assets/img/svg/T.svg" alt="Tracey logo">
        <div class="d-flex align-items-start flex-grow-1">
          <div class="fw-semibold title-wrapper line-height-1">
            {{ title ? t(title) : "" }}
          </div>
        </div>
        <div class="pe-20 d-flex">
          <button type="button" class="btn-close" aria-label="Close"
                  (click)="activeModal.dismiss('Cross click')"></button>
        </div>
      </div>
      <div class="body-wrapper">

        <table class="w-100 mb-4">
          <thead class="admin-modal-table-underline">
          <tr>
            <th>{{ t('competitor.table.startNumber') }}</th>
            <th>{{ t('app.common.name.surname') }}</th>
          </tr>
          </thead>
          <tr app-table-header-separator></tr>
          <tbody>
          <tr class="admin-modal-table-underline">
            <td class="center-align fw-semibold py-6">
              {{ competitor?.startNumber ?? '-' }}
            </td>
            <td class="center-align py-6">
              {{ (competitor?.firstName ?? '') + ' ' + (competitor?.lastName ?? '') }}
            </td>
          </tr>
          </tbody>
        </table>

        <table class="w-100 mt-4">
          <thead class="admin-modal-table-underline">
          <tr>
            <th>{{ t('organiser.event.details.control.point.type') }}</th>
            <th>{{ t('measurements.time') }}</th>
            <th>{{ t('measurements.chipTime') }}</th>
            @if (raceSettings?.resultProcessingType === ResultProcessingType.TIME_LIMITED) {
            <th>{{ t('competitor.table.distance')}}</th>
            }
            <th>&nbsp;</th>
          </tr>
          </thead>
          <tr app-table-header-separator></tr>
          <tbody>
            @for (controlTime of controlTimes; track controlTime; let idx = $index) {
              <tr class="admin-modal-table-underline">
                <td class="center-align py-6">
                  @if (controlTime.controlWaypoint?.waypointTypeId === WaypointType.CONTROL_WAYPOINT) {
                    {{
                      t("organiser.event.details.control.point.waypointType." +
                        controlTime.controlWaypoint?.waypointTypeId)
                    }}
                  <app-language-output [hrLabel]="controlTime.controlWaypoint?.pointNameHr" [enLabel]="controlTime.controlWaypoint?.pointNameEn" [srLabel]="controlTime.controlWaypoint?.pointNameSr"
                                 [itLabel]="controlTime.controlWaypoint?.pointNameIt" [siLabel]="controlTime.controlWaypoint?.pointNameSlo" [bsLabel]="controlTime.controlWaypoint?.pointNameBs" [languages]="languages"/>

                  } @else if (!controlTime.controlWaypoint && (controlTime?.lap ?? 0) > 0) {
                    {{ t('measurements.lap.label', {lap: controlTime.lap}) }}
                  } @else {
                    {{
                      t("organiser.event.details.control.point.waypointType."
                        + controlTime.controlWaypoint?.waypointTypeId)
                    }}
                  }
                </td>
                <td class="center-align py-6" [class.error]="!!controlTime.id && saveResult.get(controlTime.id!) && saveResult.get(controlTime.id!) !== CompetitorSaveControlPointResultStatus.OK">
                  {{
                    (controlTime?.time) ? (controlTime?.time | localizedDate:'dd.MM.yyyy HH:mm:ss.SSS') : '-'
                  }}
                  @if(!!controlTime.id && saveResult.get(controlTime.id!) && saveResult.get(controlTime.id!) !== CompetitorSaveControlPointResultStatus.OK) {
                    <i class="ps-2 bi bi-info-circle info-icon p" style="font-size: 14px;"
                       ngbTooltip="{{ t('measurements.competitor.control.point.save.error.' + saveResult.get(controlTime.id!)) }}"
                       placement="left">
                    </i>
                  }
                </td>
                <td class="center-align py-6">
                {{
                    (controlTime?.chipTime) ? (controlTime?.chipTime |
                        localizedDate:'dd.MM.yyyy HH:mm:ss.SSS')
                      : '-'
                  }}
                </td>
                 @if (raceSettings?.resultProcessingType === ResultProcessingType.TIME_LIMITED) {
                  <td class="center-align py-6">
                    {{controlTime?.lapDistancePassed}}
                  </td>
                }

                <td class="center-align py-6">
                   <div class="d-flex justify-content-center align-items-center">
                       <input type="radio" class="form-check-input" name="selected" [value]="controlTime.id" formControlName="selected">
                  </div>
                </td>
              </tr>
            }
          </tbody>
        </table>

        <div class="background-white pt-4 d-flex align-items-center flex-column flex-lg-row justify-content-stretch">
          <div class="flex-grow-1 pe-0 pe-md-3 pb-3 pb-lg-0 w-100-smaller-than-lg">
            <app-date-time-input formControlName="time" [displayTime]="true" [displaySeconds]="true" [minDate]="startDate" [maxDate]="finishDate"
                                 [displayMilliseconds]="true" [label]="t('measurements.time')"
                                 [openDropdownUpwards]="true"/>
          </div>
          <div class="flex-grow-1 min-width-275 pb-3 pb-lg-0 w-100-smaller-than-lg">
            <app-date-time-input formControlName="chipTime" [displayTime]="true" [displaySeconds]="true"
                                 [displayMilliseconds]="true" [label]="t('measurements.chipTime')"
                                 [openDropdownUpwards]="true"/>
          </div>
          @if (isFinishWaypoint) {
            <div class="flex-grow-1 ps-0 ps-lg-3 w-100-smaller-than-lg">
              <app-input type="number" formControlName="penaltyMinutes" [min]="0" [max]="60"
                       [maxlength]="2" [label]="t('measurements.controlpoints.penalty.minutes')"/>
            </div>
          }
          @if (displayDistanceInput) {
            <div class="flex-grow-1 ps-0 ps-lg-3">
              <app-input type="number" formControlName="lapDistancePassed" [label]="t('measurements.lap.passed.distance')"/>
            </div>
          }
        </div>
      </div>

      <div class="d-flex justify-content-center align-items-center pb-40-48">
        <div class="d-flex">
          <div class="pe-3">
            <app-rounded-button [label]="t('app.common.cancel')"
                                [btnClass]="'btn-grey text-uppercase'" (onClick)="onDismissClick()"/>
          </div>
          <app-rounded-button [label]="confirmButtonTitle ?? t('app.common.confirm')" (onClick)="onConfirmClick()"
                              [isDisabled]="!saveEnabled"
                              [btnClass]="'btn-primary-red text-uppercase'"></app-rounded-button>
        </div>
      </div>
    </div>
  </form>
</ng-container>
